import invoiceDefinition from 'invoice_definition';
global.app.sdk.invoice = global.app.create_sdk(invoiceDefinition, true);
import assetdefinition from 'asset_definition';
global.app.sdk.asset = global.app.create_sdk(assetdefinition, true);
import marketdefinition from 'market_definition';
global.app.sdk.market = global.app.create_sdk(marketdefinition, true);
import marketingdefinition from 'marketing_definition';
global.app.sdk.marketing = global.app.create_sdk(marketingdefinition, true);
import filedefinition from 'file_definition';
global.app.sdk.file = global.app.create_sdk(filedefinition, true);

